import { useTranslation } from 'react-i18next';
import { Button, Form, Switch } from 'antd';

export default function ToggleSwitch({
  form,
  name,
  onChangeAction,
  disabled = false,
}) {
  const { t } = useTranslation(['forms']);

  // `setFields` rather than `setFieldsValue`, because most call sites pass a
  // path array: `{ [name]: value }` turns that array into the object key, so
  // the write landed on a field literally called "applicationSettings,eInvoice"
  // and the real one never moved. Clicking the "No"/"Yes" labels did nothing
  // at all — only dragging the switch worked. `setFields` takes the path as it
  // is, and accepts a plain string name just as well.
  const onChange = (value) => {
    form.setFields([{ name, value }]);
    if (onChangeAction) onChangeAction(value);
  };

  return (
    <div className="flex items-center gap-2">
      <Button
        type="button"
        disabled={disabled}
        className="!h-max !w-max rounded-md !bg-transparent p-1 disabled:!bg-transparent disabled:opacity-50"
        onClick={() => onChange(false)}
      >
        {t('no', { ns: 'forms' })}
      </Button>

      <Form.Item label={null} className="!mb-0" name={name}>
        <Switch
          disabled={disabled}
          onChange={onChangeAction && onChangeAction}
        />
      </Form.Item>

      <Button
        type="button"
        disabled={disabled}
        className="!h-max !w-max rounded-md !bg-transparent p-1 disabled:!bg-transparent disabled:opacity-50"
        onClick={() => onChange(true)}
      >
        {t('yes', { ns: 'forms' })}
      </Button>
    </div>
  );
}
